import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../ui/button/button";
import { ArrowRight, Zap } from "lucide-react";
import { motion } from "framer-motion";
import styles from "./CTA.module.css";

const FEATURES_IMAGE =
  "https://res.cloudinary.com/dcryayen2/image/upload/q_auto/f_auto/v1777314271/ChatGPT_Image_Apr_27_2026_07_24_07_PM_mn4ooj.png";

export default function CTA() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className={styles.card}
        >
          <img
            src={FEATURES_IMAGE}
            alt="Mitochondrial research"
            className={styles.bgImage}
          />
          <div className={styles.overlay} />
          <div className={styles.content}>
            <div className={styles.inner}>
              <div className={styles.badge}>
                <Zap className={styles.badgeIcon} />
                <span className={styles.badgeText}>
                  Runs Locally, Your Data Stays Yours
                </span>
              </div>
              <h2 className={styles.title}>
                Put MitoAgent to Work on Your Hardest Cases
              </h2>
              <p className={styles.description}>
                MitoAgent runs locally on your machine so your data never leaves
                your environment. We are opening early access to a small number
                of research labs and clinical teams working in mitochondrial
                disease. Submit a case, run a genotype, test a hypothesis. Tell
                us where it breaks. No cost during beta, we want serious users
                who will push it to its limits.
              </p>
              <div className={styles.buttons}>
                <Link to="/playground">
                  <Button size="lg" className={styles.primaryButton}>
                    Apply for Early Access
                    <ArrowRight className={styles.buttonIcon} />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
